import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { Col, Container, Row, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// eslint-disable-next-line no-unused-vars
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../components/common/spinner/Spinner";
// eslint-disable-next-line no-unused-vars
import Error from "../../../components/common/error/Error";
import Api from "../../components/api/Api";
import Select from "react-select";
// eslint-disable-next-line no-unused-vars
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
// eslint-disable-next-line no-unused-vars
import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
// eslint-disable-next-line no-unused-vars
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

const AddUser = ({ userTypePartner }) => {
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState?.user ?? authState;
  const token = loggedInUser?.refreshToken || authState?.refreshToken || loggedInUser?.token || authState?.token;
  const userType = loggedInUser?.user?.userType?.name || loggedInUser?.userType;
  console.log(userType);
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const initialValues = {
    user_name: "",
    first_name: "",
    last_name: "",
    email_address: "",
    mobile_number: "",
    userType: {},
    role: [],
  };
  useEffect(() => {
    if (userType === "SUPER_ADMIN") {
      setSelectedUserType({ value: "", label: "Select User Type" });
    } else if (userType === "PARTNER") {
      setSelectedUserType({ value: { name: "PARTNER" }, label: "Partner" });
    } else if (userType === "CUSTOMER") {
      setSelectedUserType({ value: { name: "CUSTOMER" }, label: "Customer" });
    }
  }, [userType]);
  const getDetailsApi = Api({
    url: `admin/addUser`,
  });
  const handleSubmit = async (values, { setSubmitting }) => {
    const roleValues = selectedRoles.map((option) => option.value);

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      const currentUserId = loggedInUser?.user?.user?.id || loggedInUser?.user?.id || loggedInUser?.id || 1;

      let isSuccess = false;
      let responseMsg = "";

      // Try customer/addCustomer first
      try {
        const customerPayload = {
          first_name: values.first_name,
          last_name: values.last_name,
          mobile_number: values.mobile_number,
          email_id: values.email_address,
          user: {
            id: currentUserId,
          },
        };
        const res = await axios.post(`${baseUrl}/customer/addCustomer`, customerPayload, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (res.data?.statusType === "SUCCESS" || res.status === 200 || res.status === 201) {
          isSuccess = true;
          responseMsg = res.data?.text || "User added successfully";
        }
      } catch (customerErr) {
        // Fallback to admin/addUser
        const data = {
          user_name: "",
          first_name: values.first_name,
          last_name: values.last_name,
          email_address: values.email_address,
          mobile_number: values.mobile_number,
          userType: selectedUserType?.value || { name: "CUSTOMER" },
          role: roleValues,
        };
        const responseData = await getDetailsApi.postData(data);
        if (responseData?.data?.statusType === "SUCCESS") {
          isSuccess = true;
          responseMsg = "User added successfully";
        } else {
          responseMsg = responseData?.data?.text || "Error Adding User";
        }
      }

      if (isSuccess) {
        showToast(responseMsg || "User added successfully", {
          type: "success",
        });
        setTimeout(() => {
          navigate("/user");
        }, 1500);
      } else {
        showToast(responseMsg || "Error Adding User", {
          type: "error",
        });
      }
    } catch (error) {
      setIsError(true);
      showToast("Error Occurred", {
        type: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    mobile_number: Yup.string()
      .matches(/^(?:\+91|91)?[6-9]\d{9}$/, "Please enter a valid mobile number")
      .required("Mobile Number is required"),
  });

  const rolesOptions = [
    { value: "ROLE_ADMIN", label: "Admin" },
    { value: "ROLE_LEAD", label: "Lead" },
    { value: "ROLE_TEAM_MEMBER", label: "Team Member" },
    { value: "ROLE_FRONT_DESK", label: "Front Desk" },
    { value: "ROLE_USER", label: "User" },
  ];

  const userTypesOptions = [
    { value: "", label: "Select User Type" },
    { value: { name: "ALL_HOME_DESIRE" }, label: "All Home Desire" },
    { value: { name: "PARTNER" }, label: "Partner" },
    { value: { name: "CUSTOMER" }, label: "Customer" },
  ];

  // eslint-disable-next-line no-unused-vars
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Team Management", link: "/user" },
    { label: "Add User Details", link: "", active: true },
  ];
  console.log("your selelcted user type is ", selectedUserType);
  return (
    <div className="user-page">
      <div className="user-page__inner">
        

        <main className="user-page__content">
          <div className="user-page__header">
            <div>
              <span className="user-page__eyebrow">User Management</span>
              <h1 className="user-page__title">Add User</h1>
            </div>
          </div>

          <div className="user-page__card">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="add-user__form">
                  <div className="add-user__grid">
                    <div className="add-user__field">
                      <label>First Name</label>
                      <Field
                        type="text"
                        name="first_name"
                        placeholder="Enter First Name"
                      />
                      <ErrorMessage
                        name="first_name"
                        component="div"
                        className="add-user__error"
                      />
                    </div>

                    <div className="add-user__field">
                      <label>Last Name</label>
                      <Field
                        type="text"
                        name="last_name"
                        placeholder="Enter Last Name"
                      />
                      <ErrorMessage
                        name="last_name"
                        component="div"
                        className="add-user__error"
                      />
                    </div>
                  </div>

                  <div className="add-user__grid">
                    <div className="add-user__field">
                      <label>Email Address</label>
                      <Field
                        type="email"
                        name="email_address"
                        placeholder="Enter Email"
                      />
                      <ErrorMessage
                        name="email_address"
                        component="div"
                        className="add-user__error"
                      />
                    </div>

                    <div className="add-user__field">
                      <label>Mobile Number</label>
                      <Field
                        type="text"
                        name="mobile_number"
                        placeholder="Enter Phone Number"
                      />
                      <ErrorMessage
                        name="mobile_number"
                        component="div"
                        className="add-user__error"
                      />
                    </div>
                  </div>

                  {userType === "SUPER_ADMIN" && (
                    <div className="add-user__field">
                      <label>User Type</label>
                      <Select
                        options={userTypesOptions}
                        onChange={setSelectedUserType}
                        value={selectedUserType}
                        placeholder="Select User Type"
                      />
                    </div>
                  )}

                  {selectedUserType?.value?.name !== "CUSTOMER" && (
                    <div className="add-user__field">
                      <label>Role</label>
                      <Select
                        options={rolesOptions}
                        isMulti
                        onChange={setSelectedRoles}
                        value={selectedRoles}
                        placeholder="Select Role"
                      />
                    </div>
                  )}

                  <button
                    type="submit"
                    className="user-page__btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <Spinner loading /> : "Add User"}
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddUser;
